import settingsActionCreatorFactory from 'typescript-fsa'
import { Theme } from '@mui/material'
import { Member, Message, User, UserPermissions } from '../../shared/types'

export const settingsActionCreator = settingsActionCreatorFactory('SETTINGS')

/**
 * Actions
 */

// settings actions
export const setPrefersDarkMode = settingsActionCreator<boolean>('SET_DARK_MODE')
export const setTheme = settingsActionCreator<Theme>('SET_THEME')
export const setMessage = settingsActionCreator<Message>('SET_MESSAGE')
export const setSearchInput = settingsActionCreator<string | undefined>('SET_SEARCH_INPUT')
export const setUserPermissions = settingsActionCreator<UserPermissions>('SET_USER_PERMISSIONS')
export const setNavPoint = settingsActionCreator<string[]>('SET_NAV_POINT')
export const setBiography = settingsActionCreator<string>('SET_BIOGRAPHY')
export const setGeography = settingsActionCreator<string>('SET_GEOGRAPHY')
export const setUser = settingsActionCreator<User | undefined>('SET_USER')
export const setActiveMember = settingsActionCreator<Member | undefined>('SET_ACTIVE_MEMBER')
export const setRedirectPath = settingsActionCreator<string | undefined>('SET_REDIRECT_PATH')
